export var formatPhoneNumber = function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  } else {
    if ((phoneNumberString === null || phoneNumberString === void 0 ? void 0 : phoneNumberString.length) === 10) {
      return "(".concat(phoneNumberString.slice(0, 3), ") ").concat(phoneNumberString.slice(3, 7), "-").concat(phoneNumberString.slice(7));
    }
  }

  return phoneNumberString;
};